import React from 'react';
import './Tag.css';
import { typeTagNames} from '../../../models/tag_representations';

const TypeTag = ({ reportType, isButton, onButtonClick }) => {
    if (!reportType) return null;

    return isButton ? (
        <button 
            className={`tag-button ${reportType}`}
            title="this is a tag"
            onClick={onButtonClick}
        >
            {typeTagNames[reportType]}
        </button>
    ) : (
        <div 
            className={`tag ${reportType}`}
            // title="this is a tag"
        >
            {typeTagNames[reportType]}
        </div>
    );
};

export default TypeTag;
